import jQuery from 'jquery';
/*
Built on Source code created by Rustici Software, LLC is licensed under a
Creative Commons Attribution 3.0 United States License
(http://creativecommons.org/licenses/by/3.0/us/)
*/


const debug = true; // set to true while testing
window.SCORMAPI = null;


// a little hack so that we can use console.log to debug in IE8

if (typeof console === 'undefined' || typeof console.log === 'undefined') {
  console = {};
  if (debug === true) {
    console.log = function (msg) {
      alert(msg);
    };
  } else {
    console.log = function () {};
  }
}

// Include the standard ADL-supplied API discovery algorithm


// /////////////////////////////////////////
// Begin ADL-provided API discovery algorithm
// /////////////////////////////////////////
let findAPITries = 0;


function findAPI(win)
{
  // Check to see if the window (win) contains the API
  // if the window (win) does not contain the API and
  // the window (win) has a parent window and the parent window
  // is not the same as the window (win)
  try {
    while ( (win.API == null) && (win.parent != null) && (win.parent != win) )
    {
      // increment the number of findAPITries
      findAPITries++;

      // Note: 7 is an arbitrary number, but should be more than sufficient
      if (findAPITries > 7)
      {
        if (debug === true) {
          console.log("Error finding API -- too deeply nested.");
        }
        return null;
      }

      // set the variable that represents the window being
      // being searched to be the parent of the current window
      // then search for the API again
      win = win.parent;
    }
  return win.API;
  } catch (e) {
    if (debug === true) {
      console.log('Had a problem finding the SCORM API wrapper');
    }
  }
}

function getAPI()
{
  if (debug === true) {
    console.log('Entering getAPI');
  }

  // start by looking for the API in the current window
  var theAPI = findAPI(window);

  // if the API is null (could not be found in the current window)
  // and the current window has an opener window
  if ( (theAPI == null) && (window.opener != null) && (typeof(window.opener) != "undefined") )
  {
    // try to find the API in the current window’s opener
    theAPI = findAPI(window.opener);
  }
  // if the API has not been found
  if (theAPI == null)
  {
    if (debug === true) {
      // Alert the user that the API Adapter could not be found
      console.log("Unable to find an API adapter");
    }
  }

  if (debug === true) {
    console.log('Leaving getAPI');
  }
  return theAPI;
}

// /////////////////////////////////////////
// End ADL-provided API discovery algorithm
// /////////////////////////////////////////


// Create function handlers for the loading and unloading of the page


// Constants
const SCORM_TRUE = 'true';
const SCORM_FALSE = 'false';
const SCORM_NO_ERROR = '0';
const SCORM_NOT_INITIALIZED = '301';

// Since the Unload handler will be called twice, from both the onunload
// and onbeforeunload events, ensure that we only call LMSFinish once.
let finishCalled = false;

// Track whether or not we successfully initialized.
let initialized = false;

function ScormProcessInitialize() {
  if (debug === true) {
    console.log('Entering ScormProcessInitialize');
  }
  let result;

  window.SCORMAPI = getAPI();

  if (window.SCORMAPI == null) {
    if (debug === true) {
      // console.error("ERROR - Could not establish a connection with the LMS.\n\nYour results may not be recorded.");
    }
    return;
  }

  window.SCORMAPI.LMSGetValue('cmi.core.lesson_status');

  if(window.SCORMAPI.LMSGetLastError() == SCORM_NOT_INITIALIZED) {
      result = window.SCORMAPI.LMSInitialize('');

      if (result == SCORM_FALSE) {
          const errorNumber = window.SCORMAPI.LMSGetLastError();
          const errorString = window.SCORMAPI.LMSGetErrorString(errorNumber);
          const diagnostic = window.SCORMAPI.LMSGetDiagnostic(errorNumber);

          const errorDescription = `Number: ${errorNumber}\nDescription: ${errorString}\nDiagnostic: ${diagnostic}`;

          if (debug === true) {
              // console.error("Error - Could not initialize communication with the LMS.\n\nYour results may not be recorded.\n\n" + errorDescription);
          }
          return;
      }
  }

  initialized = true;
  if (debug === true) {
    console.log('Leaving ScormProcessInitialize');
  }
}

function ScormProcessFinish() {
  if (debug === true) {
    console.log('Entering ScormProcessFinish');
  }
  let result;

  // Don't terminate if we haven't initialized or if we've already terminated
  if (initialized == false || finishCalled == true) {
    	if (debug === true) {
      // console.info("Leaving ScormProcessInitialize (not itialized or already terminated)");
    }
    	return;
  }

  result = window.SCORMAPI.LMSFinish('');

  finishCalled = true;

  if (result == SCORM_FALSE) {
    const errorNumber = window.SCORMAPI.LMSGetLastError();
    const errorString = window.SCORMAPI.LMSGetErrorString(errorNumber);
    const diagnostic = window.SCORMAPI.LMSGetDiagnostic(errorNumber);

    const errorDescription = `Number: ${errorNumber}\nDescription: ${errorString}\nDiagnostic: ${diagnostic}`;

    if (debug === true) {
      // console.error("Error - Could not terminate communication with the LMS.\n\nYour results may not be recorded.\n\n" + errorDescription);
    }
    return;
  }
  if (debug === true) {
    console.log('Leaving ScormProcessInitialize');
  }
}

function ScormProcessCommit() {
    if (debug === true) {
        console.log('Entering ScormProcessCommit');
    }
    let result;

    // Don't terminate if we haven't initialized or if we've already terminated
    if (initialized == false || finishCalled == true) {
        if (debug === true) {
            // console.info("Leaving ScormProcessInitialize (not itialized or already terminated)");
        }
        return;
    }

    result = window.SCORMAPI.LMSCommit('');

    finishCalled = true;

    if (result == SCORM_FALSE) {
        const errorNumber = window.SCORMAPI.LMSGetLastError();
        const errorString = window.SCORMAPI.LMSGetErrorString(errorNumber);
        const diagnostic = window.SCORMAPI.LMSGetDiagnostic(errorNumber);

        const errorDescription = `Number: ${errorNumber}\nDescription: ${errorString}\nDiagnostic: ${diagnostic}`;

        if (debug === true) {
            // console.error("Error - Could not terminate communication with the LMS.\n\nYour results may not be recorded.\n\n" + errorDescription);
        }
        return;
    }
    if (debug === true) {
        console.log('Leaving ScormProcessInitialize');
    }
}


export function ScormProcessGetValue(element) {
  if (debug === true) {
    console.log(`Entering ScormProcessGetValue. element: ${element}`);
  }
  let result;

  if (initialized == false || finishCalled == true) {
    if (debug === true) {
      // console.error("Error - Could not retrieve a value from the LMS. Initialized = "+initialized+" finishCalled "+finishCalled+"\n\n");
    }
    return;
  }

  result = window.SCORMAPI.LMSGetValue(element);

  if (result == '') {
    const errorNumber = window.SCORMAPI.LMSGetLastError();

    if (errorNumber != SCORM_NO_ERROR) {
      const errorString = window.SCORMAPI.LMSGetErrorString(errorNumber);
      const diagnostic = window.SCORMAPI.LMSGetDiagnostic(errorNumber);

      const errorDescription = `Number: ${errorNumber}\nDescription: ${errorString}\nDiagnostic: ${diagnostic}`;

      if (debug === true) {
        // console.error("Error - Could not retrieve a value from the LMS.\n\n" + errorDescription);
      }
      return '';
    }
  }
  if (debug === true) {
    console.log(`Leaving ScormProcessGetValue. result: ${result}`);
  }
  return result;
}

export function ScormProcessSetValue(element, value,options) {
   	if (debug === true) {
    console.log(`Entering ScormProcessSetValue. element: ${element} value: ${value}`);
  }
  let result;

  if (initialized == false || finishCalled == true) { return; }

  result = window.SCORMAPI.LMSSetValue(element, value);

  if (result == SCORM_FALSE) {
    const errorNumber = window.SCORMAPI.LMSGetLastError();
    const errorString = window.SCORMAPI.LMSGetErrorString(errorNumber);
    const diagnostic = window.SCORMAPI.LMSGetDiagnostic(errorNumber);

    const errorDescription = `Number: ${errorNumber}\nDescription: ${errorString}\nDiagnostic: ${diagnostic}`;

    if (debug === true) {
      // console.error("Error - Could not store a value in the LMS.\n\nYour results may not be recorded.\n\n" + errorDescription);
    }
    if(element=='cmi.core.lesson_status'){
        alert('Failed Recording Course Completion')
    }
    return;
  } else {

      if(options && (options['closeWindow']==true)){
          setTimeout(function(){
              window.parent.close()
          }, 4000);
      }
  }
  if (debug === true) {
    console.log('Leaving ScormProcessSetValue');
  }
}
window.ScormProcessSetValue = ScormProcessSetValue;

 		/** ********************************** */
// navigation functions
/** ********************************** */

let currentPage = null;
let startTimeStamp = null;
let processedUnload = false;
const reachedEnd = false;

function doStart() {
  if (debug === true) {
    console.log('Entering doStart');
  }
  // record the time that the learner started the SCO so that we can report the total time
  startTimeStamp = new Date();

  // initialize communication with the LMS
  ScormProcessInitialize();

  // it's a best practice to set the lesson status to incomplete when
  // first launching the course (if the course is not already completed)
  const completionStatus = ScormProcessGetValue('cmi.core.lesson_status');
  if (completionStatus == 'not attempted') {
    // ScormProcessSetValue("cmi.core.lesson_status", "incomplete");
  }

  // see if the user stored a bookmark previously (don't check for errors
  // because cmi.core.lesson_location may not be initialized
  const bookmark = ScormProcessGetValue('cmi.core.lesson_location');

    // if there isn't a stored bookmark, start the user at the first page
    if (bookmark == '') {
        currentPage = 0;
    } else {
        currentPage = parseInt(bookmark, 10); // Just set it for now, later we could prompt the user:
        // if there is a stored bookmark, prompt the user to resume from the previous location
        //        if (confirm("Would you like to resume from where you previously left off?")){
        //            currentPage = parseInt(bookmark, 10);
        //        }
        //        else{
        //            currentPage = 0;
        //        }
    }
    if (window.scormRESUME == 1) {
        enterResumeFunction();
    }
    if (window.scormRESUME == 0) {
        registerButtonEvent();
        checkPreviousLocation();
    }


    if (debug === true) {
        console.log('Leaving doStart');
    }
}


function enterResumeFunction() {
    if (debug) {
        console.log('entering SCORM resume function')
    }

    createResumeModalBox();
    checkPreviousLocation();
    registerButtonEvent()


}

function registerButtonEvent() {
    $('.gh__button-block').on('click', function () {
        setTimeout(() => {
            updateSuspendData();
        }, 800)
    })
}


function createResumeModalBox() {
    const modalWrapper = $('<div class="gh-modal modal container" id="resume-modal" tabindex="-1" role="dialog" style="align-items: center;justify-content: center;"></div>')
    const modalDialog = $('<div class="modal-dialog gh__modal__wrapper-outer" role="document" style="max-width: 400px;"></div>')
    const modalContent = $('<div class="modal-content js__modal__content gh__modal__wrapper-inner" style="max-height: 200px;"></div>')
    const modalBody = $('<div class="modal-body gh__modal__body js__modal__content gh__modal__body--content-only" style="align-items: center; justify-content: center;"><p>You have previously been in this lesson. To pick up where you left off, click Continue. To go to the beginning, click Beginning</p></div>')
    const modalFooter = $('<div class="modal-footer"></div>')
    const resumeCancel = $('<button type="button" id = "btn-resume-cancel" class="btn btn-default" data-dismiss="modal">Beginning</button>').on('click', function () {
        updateSuspendData();
        $('#resume-modal').hide()

    })
    const resumeContinue = $('<button type="button" id="btn-resume-continue" class="btn btn-primary" >Continue</button>').on('click', function () {
        continueResume()
    })
    $(modalFooter).append(resumeCancel)
    $(modalFooter).append(resumeContinue)
    $(modalContent).append(modalBody)
    $(modalContent).append(modalFooter)
    $(modalDialog).append(modalContent)
    $(modalWrapper).append(modalDialog)
    $('body').append(modalWrapper)

}

function checkPreviousLocation() {
    const suspendData = getSuspendData()
    const suspenseValue = suspendData && suspendData.resumeLocation && suspendData.resumeLocation.pageName;
    if (debug) {
        console.log('Suspend data on checkPreviousLocation is ', suspendData)
    }
    if (suspenseValue) {
        const currentPath = getPathFileName();
        if (currentPath != suspendData.resumeLocation.pageName && window.history.length == 1) {
            $('#resume-modal').show()

        } else if (currentPath == suspendData.resumeLocation.pageName) {
            const hasSceneId = suspendData && suspendData.resumeLocation && suspendData.resumeLocation.sceneId;
            if (hasSceneId) {
                $('.sequence-activity-row ').hide();
                $(`#${hasSceneId}`).show();

            }
            setTimeout(() => {
                updateSuspendData()
            }, 800)
        } else {
            setTimeout(() => {
                updateSuspendData()
            }, 800)
        }

    } else {
        setTimeout(() => {
            updateSuspendData()
        }, 800)
    }


}


function updateSuspendData() {
    if (debug) {
        console.log('Update start for suspend data ')
    }
    const filter = $('.sequence-activity-row ').filter(function () {
        return ($(this).is(':visible'))
    })
    let sceneId = null;
    if (filter && filter.length > 0) {
        sceneId = $(filter[0]).attr('id')

    }
    const currentPath = getPathFileName();
    const suspendData = getSuspendData()
    const resumeLocation = {pageName: currentPath, sceneId}
    const updateSuspendData = {...suspendData, resumeLocation}
    const encoded = encodeBase64(updateSuspendData)
    if (window.SCORMAPI) {
        ScormProcessSetValue('cmi.suspend_data', encoded);
    } else {
        window.Cookies.set('cmi.suspend_data', encoded);
    }
    if (debug) {
        console.log('Updated Suspend data with value', updateSuspendData)
    }

}


function getPathFileName() {
    const pathname = window.location.pathname;
    const split = pathname.split('/');
    const lastItem = split[split.length - 1];
    if (lastItem) {
        return lastItem;
    }
    return split[split.length - 2];  // This is required when the url is 'http://localhost:8081/hse-induction/' rather than http://localhost:8081/hse-induction
}


function continueResume() {
    const getData = getSuspendData()
    if (getData && getData.resumeLocation && getData.resumeLocation.pageName) {
        if (debug) {
            console.log('Resume will conitnue on page', getData.resumeLocation.pageName)
        }
        window.location.replace(getData.resumeLocation.pageName)
    }

}


export function getSuspendData() {
    if (window.SCORMAPI) {
        const getScormValue = ScormProcessGetValue('cmi.suspend_data');
        return getScormValue ? decodeBase64(getScormValue) : {};

    } else {
        const cookieValue = window.Cookies.get('cmi.suspend_data')
        return cookieValue ? decodeBase64(cookieValue) : {};
    }
}


export function decodeBase64(string) {
    if (string && string !== 'null') {
        try {
            return JSON.parse(decodeURIComponent(atob(string)));
        } catch (e) {
            console.error(string, e, 'Error in parsing ');
            return {}
        }
    }

}

export function encodeBase64(string) {
    if (!string) return undefined
    return btoa(encodeURIComponent(JSON.stringify(string)))
}


function doUnload(pressedExit) {
  if (debug === true) {
    console.log('Entering doUnload');
  }
  // don't call this function twice
  if (processedUnload == true) { return; }

  processedUnload = true;

  // record the session time
  const endTimeStamp = new Date();
  if (startTimeStamp) {
    const totalMilliseconds = (endTimeStamp.getTime() - startTimeStamp.getTime());
    const scormTime = ConvertMilliSecondsToSCORMTime(totalMilliseconds, false);

    ScormProcessSetValue('cmi.core.session_time', scormTime);
  }
  // if the user just closes the browser, we will default to saving
  // their progress data. If the user presses exit, he is prompted.
  // If the user reached the end, the exit normall to submit results.
  if (pressedExit == false && reachedEnd == false) {
    ScormProcessSetValue('cmi.core.exit', 'suspend');
  }

    ScormProcessCommit();
}


function doExit() {
  if (debug === true) {
    console.log('Entering doExit');
  }
  // note use of short-circuit AND. If the user reached the end, don't prompt.
  // just exit normally and submit the results.
  if (reachedEnd == false && confirm('Would you like to save your progress to resume later?')) {
    // set exit to suspend
    ScormProcessSetValue('cmi.core.exit', 'suspend');
  } else {
    // set exit to normal
    ScormProcessSetValue('cmi.core.exit', '');
  }

  // process the unload handler to close out the session.
  // the presense of an adl.nav.request will cause the LMS to
  // take the content away from the user.
  doUnload(true);
  if (debug === true) {
    console.log('Leaving doExit');
  }
}

// called whenever a modal is closed to record the progress
// passes in score as a percentage
export function RecordTest(score, activityname) {
  if (typeof activityname === 'undefined') return; // don't know why, but this is being called when the unit is first loaded
  const activitynum = ScormProcessGetValue('cmi.objectives._count');
  activityname = activityname.replace(/[^a-zA-Z0-9]/g, '_');
  if (debug === true) {
    console.log(`Entering RecordTest. score: ${score} activityname: ${activityname}`);
  }
  ScormProcessSetValue(`cmi.objectives.${activitynum}.id`, activityname);
  ScormProcessSetValue(`cmi.objectives.${activitynum}.score.raw`, '1');
  ScormProcessSetValue(`cmi.objectives.${activitynum}.score.min`, '0');
  ScormProcessSetValue(`cmi.objectives.${activitynum}.score.max`, '1');
  ScormProcessSetValue(`cmi.objectives.${activitynum}.status`, 'completed');
  score = typeof score !== 'undefined' ? score : '0';
  ScormProcessSetValue('cmi.core.score.raw', score);
  ScormProcessSetValue('cmi.core.score.min', '0');
  ScormProcessSetValue('cmi.core.score.max', '100');

  if (debug === true) {
    console.log('Leaving RecordTest');
  }
}
window.RecordTest = RecordTest;

// called to do brute force completion.
export function RecordCompletion() {
  ScormProcessSetValue('cmi.core.lesson_status', 'completed');
  if (debug === true) {
    console.log('Leaving RecordCompletion');
  }
}
window.RecordCompletion = RecordCompletion;


// called whenever an activity with a score component is completed
// this might be when an option is clicked on (as in a multiple choice activity), or when the feedback button is clicked
export function RecordSCORMinteraction(activityname, rawscore, response) {
  if (typeof activityname === 'undefined') return; // don't know why, but this is being called when the unit is first loaded
  const activitynum = ScormProcessGetValue('cmi.interactions._count');
  response = typeof response !== 'undefined' ? response : '';
  rawscore = typeof rawscore !== 'undefined' ? rawscore : '0';
  // if (debug===true) { console.log("Entering RecordActivity. activityname: "+ activityname+" activitynum: "+ activitynum+" rawscore: "+ rawscore+" minscore: "+ minscore+" maxscore: "+ maxscore); }
  if (debug === true) {
    console.log(`Entering RecordSCORMinteraction. activityname: ${activityname} rawscore: ${rawscore} response: ${response}`);
  }

  ScormProcessSetValue(`cmi.interactions.${activitynum}.id`, activityname.replace(/[^a-zA-Z0-9]/g, '_'));
  ScormProcessSetValue(`cmi.interactions.${activitynum}.student_response`, response.replace(/[^a-zA-Z0-9]/g, '_'));
  ScormProcessSetValue(`cmi.interactions.${activitynum}.result`, rawscore);


  /* using interactions now. left this in case things go horribly wrong
    activitynum = ScormProcessGetValue("cmi.objectives._count"); // I gave up on trying to get this from the CMS
    // set up default values (in case they are not passed to the RecordActivity function)
    minscore = typeof minscore !== 'undefined' ? minscore : 0;
    maxscore = typeof maxscore !== 'undefined' ? maxscore : 100;
    description = typeof description !== 'undefined' ? description : '';
    // OK, since we can't use SCORM 2004 fields, and SCORM 1.2 interactions won't let me set score max and min I've decided to munge the question and answer into the ID field...
    newid = activityname.replace(/[^a-zA-Z0-9]/g, '_') + '_' + description.replace(/[^a-zA-Z0-9]/g, '_');
    newid = newid.substring(0,255);
    // send them off to the LMS
    ScormProcessSetValue("cmi.objectives."+activitynum+".id", newid);
    ScormProcessSetValue("cmi.objectives."+activitynum+".score.raw", String(rawscore));
    ScormProcessSetValue("cmi.objectives."+activitynum+".score.min", String(minscore));
    ScormProcessSetValue("cmi.objectives."+activitynum+".score.max", String(maxscore));
    // ScormProcessSetValue("cmi.objectives."+activitynum+".description", description); // only available in Scorm 2004 :-(
    ScormProcessSetValue("cmi.objectives."+activitynum+".status", "completed");
*/
  if (debug === true) {
    console.log('Leaving RecordActivity');
  }
}
window.RecordSCORMinteraction = RecordSCORMinteraction;

// SCORM requires time to be formatted in a specific way
function ConvertMilliSecondsToSCORMTime(intTotalMilliseconds, blnIncludeFraction) {
  if (debug === true) {
    console.log(`Entering ConvertMilliSecondsToSCORMTime. intTotalMilliseconds: ${intTotalMilliseconds} blnIncludeFraction: ${blnIncludeFraction}`);
  }
  let intHours;
  let intMinutes;
  let intSeconds;
  let intMilliseconds;
  let intHundredths;
  let strCMITimeSpan;

  if (blnIncludeFraction == null || blnIncludeFraction == undefined) {
    blnIncludeFraction = true;
  }

  // extract time parts
  intMilliseconds = intTotalMilliseconds % 1000;

  intSeconds = ((intTotalMilliseconds - intMilliseconds) / 1000) % 60;

  intMinutes = ((intTotalMilliseconds - intMilliseconds - (intSeconds * 1000)) / 60000) % 60;

  intHours = (intTotalMilliseconds - intMilliseconds - (intSeconds * 1000) - (intMinutes * 60000)) / 3600000;

  /*
  deal with exceptional case when content used a huge amount of time and interpreted CMITimstamp
  to allow a number of intMinutes and seconds greater than 60 i.e. 9999:99:99.99 instead of 9999:60:60:99
  note - this case is permissable under SCORM, but will be exceptionally rare
  */

  if (intHours == 10000) {
    intHours = 9999;

    intMinutes = (intTotalMilliseconds - (intHours * 3600000)) / 60000;
    if (intMinutes == 100) {
	    intMinutes = 99;
    }
    intMinutes = Math.floor(intMinutes);

    intSeconds = (intTotalMilliseconds - (intHours * 3600000) - (intMinutes * 60000)) / 1000;
    if (intSeconds == 100) {
	    intSeconds = 99;
    }
    intSeconds = Math.floor(intSeconds);

    intMilliseconds = (intTotalMilliseconds - (intHours * 3600000) - (intMinutes * 60000) - (intSeconds * 1000));
  }

  // drop the extra precision from the milliseconds
  intHundredths = Math.floor(intMilliseconds / 10);

  // put in padding 0's and concatinate to get the proper format
  strCMITimeSpan = `${ZeroPad(intHours, 4)}:${ZeroPad(intMinutes, 2)}:${ZeroPad(intSeconds, 2)}`;

  if (blnIncludeFraction) {
    strCMITimeSpan += `.${intHundredths}`;
  }

  // check for case where total milliseconds is greater than max supported by strCMITimeSpan
  if (intHours > 9999) {
    strCMITimeSpan = '9999:99:99';

    if (blnIncludeFraction) {
	    strCMITimeSpan += '.99';
    }
  }
  if (debug === true) {
    console.log('Leaving ConvertMilliSecondsToSCORMTime');
  }
  return strCMITimeSpan;
}

function ZeroPad(intNum, intNumDigits) {
 	if (debug === true) {
    console.log(`Entering ConvertMilliSecondsToSCORMTime. intNum: ${intNum} intNumDigits: ${intNumDigits}`);
  }

  let strTemp;
  let intLen;
  let i;

  strTemp = new String(intNum);
  intLen = strTemp.length;

  if (intLen > intNumDigits) {
    strTemp = strTemp.substr(0, intNumDigits);
  } else {
    for (i = intLen; i < intNumDigits; i++) {
	    strTemp = `0${strTemp}`;
    }
  }
  if (debug === true) {
    console.log('Leaving ZeroPad');
  }
  return strTemp;
}

export function setupSCORM() {
  jQuery(document).ready(() => {
    doStart();
  });
  jQuery(window).on('unload', () => {
    doUnload();
  });
}



// WEBPACK FOOTER //
// Glasshouse/Core/js/scormfunctions.js